import { computedFn } from 'mobx-utils/lib/computedFn';
import { lazyShowFindTimeComposePane } from 'findtime-compose';
import { createAppButton } from 'owa-command-ribbon';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import type { IButtonStyles } from '@fluentui/react';
import { ActionControlId } from 'owa-ribbon-ids';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import { findTime_Button_ActionControl } from '../../utils/actionControlStrings.locstring.json';
import CalendarClockRegular from 'owa-fluent-icons-svg/lib/icons/CalendarClockRegular';
import loc from 'owa-localize';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { getHoverTooltip } from '../../utils/HoverTooltips/getHoverTooltip';
import { callEditorApi } from 'owa-editor/lib/utils/callEditorApi';

const showFindTimeComposePane = computedFn(
    (
        viewState: EditorViewState | undefined,
        getAllRecipients: () => EmailAddressWrapper[][],
        getSubject: () => string,
        handleFinalTable: (content: string) => null | Promise<void>
    ) => {
        return () => {
            if (viewState) {
                const targetWindow = callEditorApi(viewState, 'getDocument')?.defaultView || window;
                lazyShowFindTimeComposePane.importAndExecute(
                    viewState.editorId,
                    getAllRecipients,
                    getSubject,
                    handleFinalTable,
                    targetWindow
                );
            }
        };
    }
);

export const getFindTime = computedFn(
    (
        viewState: EditorViewState | undefined,
        getAllRecipients: () => EmailAddressWrapper[][],
        getSubject: () => string,
        handleFinalTable: (content: string) => null | Promise<void>,
        styles: IButtonStyles | undefined
    ): RibbonControlProps => {
        const label = loc(findTime_Button_ActionControl);
        return createAppButton(
            getComposeRibbonId(ActionControlId.FindTime, viewState),
            label,
            showFindTimeComposePane(viewState, getAllRecipients, getSubject, handleFinalTable),
            undefined /* keytipProps */,
            CalendarClockRegular,
            '#D1522E' /* iconColor */,
            styles,
            {
                customTooltip: getHoverTooltip(ActionControlId.FindTime, label),
            }
        );
    }
);
